export default class Modal {
  constructor(options) {
    this.container = document.querySelector(options.container) || null;
    this.modalOverlayCls = options.modalOverlayCls || '';
    this.btnCloseModal = document.querySelectorAll(options.btnCloseModal) || null;
    this.hideCls = 'hidden';
    this.init();
    this.closeCallback = options.closeCallback || null;
  }
  init() {
    if (!this.container) return;
    this.handleClickOnBtnClose();
    this.handleClickOnOverlay();
    this.openModal();
  }
  openModal() {
    if (!this.container) return;
    this.container.classList.remove(this.hideCls);
  }
  closeModal() {
    if (!this.container) return;
    this.container.classList.add(this.hideCls);
  }
  handleClickOnBtnClose() {
    this.btnCloseModal.forEach(btnItem => {
      btnItem.addEventListener('click', e => {
        e.preventDefault();
        this.closeModal();
        this.closeCallback();
      });
    });
  }
  handleClickOnOverlay() {
    this.container.addEventListener('click', e => {
      if (e.target.classList.contains(this.modalOverlayCls)) {
        this.closeModal();
      }
    });
  }
}